module.exports = __webpack_public_path__ + "static/branch-5d4b21ed0866f975af6bbf6db4f5abdd.svg";